import $ from 'jquery';
import 'bootstrap';

$(function(){

  var myOffcanvas = document.getElementById('offcanvasRight')
  myOffcanvas.addEventListener('show.bs.offcanvas', 
  function () {
    $('.burger-menu div').addClass('white');
    $('.burger-menu2').addClass('hide');
    $('.burger-menu1, .burger-menu3').addClass('rotate');
  })

  myOffcanvas.addEventListener('hide.bs.offcanvas', 
  function () {
    $('.burger-menu div').removeClass('white');
    $('.burger-menu2').removeClass('hide');
    $('.burger-menu1, .burger-menu3').removeClass('rotate');
  })

});